<template>
 <page>

   <head-nav title="language.update_call_sick">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

<scroll-page>
    <page-padding>
      
      <!--<button-deactivate v-show="computeUserAccessCallBetter" :active="buttonActive" v-on:click.native="delete_absence()" :title="computeTitleCured"></button-deactivate>-->
      <divider title=""/>
      
      <ui-input title="language.date" type="date" v-bind:val="date" @input="(v)=>{date = v}"></ui-input>
      <ui-input title="language.name_parent" type="text" v-bind:val="parentName" :readonly="true"></ui-input>
      <ui-input title="language.name_child" type="text" v-bind:val="nameChild" @input="(v)=>{nameChild = v}" :readonly="true"></ui-input>
     
      <!--<ui-select title="language.name_group" type="text" :select="computeGroups" v-bind:val="groupId" @input="(v)=>{groupId = v}"></ui-select>-->
      
      <ui-textarea title="language.description_if_relevant" v-bind:val="description" @input="(v)=>{description = v}"></ui-textarea>
     
     <ui-select @input="(v)=>{reason=v}" title="language.reason" :select='computeReasons'></ui-select>
     <ui-select @input="(v)=>{duration=v}" title="language.duration" :select='computeDuration'></ui-select>
     <!--
     <ui-input title="language.telephone" type="number" v-bind:val="tel1" @input="(v)=>{tel1 = v}"></ui-input>
     <ui-input title="language.telephone_alt" type="number" v-bind:val="tel2" @input="(v)=>{tel2 = v}"></ui-input>
    -->
     <ui-input title="language.email" type="email" :readonly="true" v-bind:val="email" @input="(v)=>{email = v}"></ui-input>
      
      <divider title=""/>
      <button-activate :active="buttonActive" v-on:click.native="confirm()" :title="computeTitle"></button-activate>
      
     </page-padding>
</scroll-page>  
   </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page.vue';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
//import ButtonDeactivate from '../components/buttons/ButtonDeactivate.vue';
import PagePadding from '../components/PagePadding.vue';
import ScrollPage from '../components/ScrollPage.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import UiInput from '../components/UiInput.vue';
import UiTextarea from '../components/UiTextarea.vue';
import { modalService } from '../services/ModalService.js';
import i18n from "../language.js";
import { history } from "../services/History.js";
import Divider from '../components/dividers/Divider.vue';
//import { USER_LEVEL } from '../settings/USER_LEVEL.js';
import UiSelect from '../components/UiSelect.vue'
import { absenceSettings } from '../settings/AbsenceSettings.js';
import { helper } from '../services/Helper.js';

export default {
  name: 'update-absence-page',
  data:function(){
    return{
      group_id:this.$route.params.id,
      date:"",
      absenceId:this.$route.params.absence_id,
      nameChild:"",
      parentName:"",
      reason:"",
      description:"",
      duration:0,
      tel1:"",
      tel2:"",
      email:"",
      buttonActive:true,
      absence:{}, /* loaded absence */
      absence_reasons:[],
    }
  },
  computed:{
    ...mapState([
       'appSettings','user_schools','groups','group'
       ]),
       computeTitle(){
        if(!this.buttonActive){
          return this.$t('language.working');
        }else{
           return this.$t('language.update_call_sick');
        }
      },
      computeTitleCured(){
        if(!this.buttonActive){
          return this.$t('language.working');
        }else{
           return this.$t('language.cured_call_sick');
        }
      },
       computeReasons(){
        
        // calculate selected reason,copy reasons array
        let result=Array.from(this.absence_reasons)

        var new_array= result.map(item =>{
          if(item.value==this.reason){
            item.selected=true
          }else{
            item.selected=false
          }
          return item;
        })
       
        return new_array;
       },
       computeDuration(){
        var result=absenceSettings.getDurations();

        var selected=result.find(item => item.value==this.duration);
        if(selected){
          selected.selected=true;
        }


        return result;
       },
  },
  components: {
    ButtonActivate,
    //ButtonDeactivate,
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    UiInput,
    UiTextarea,
    Page,
    ScrollPage,
    Divider,
    UiSelect,
  },
  methods:{
    back(){
     this.$router.push(history.get());
    },
    initForm(){
     
      // set date to today;
      var today=new Date();
      
      // set date?
      this.date= this.formatDate(today)

      var tomorrow = new Date();
      tomorrow.setDate(new Date().getDate()+1);

      this.datePresentAgain= this.formatDate(tomorrow);

    },
    
    isFormComplete(){
      
      if(this.date===""){
          modalService.createAlert(i18n.t('language.form_incomplete_date'))
        return false;
      }

      if(this.nameChild===""){
          modalService.createAlert(i18n.t('language.form_incomplete_name_child'))
        return false;
      }

      if(this.reason===""){
          modalService.createAlert(i18n.t('language.form_incomplete_reason'))
        return false;
      }

      if(this.duration===""){
          modalService.createAlert(i18n.t('language.form_incomplete_duration'))
        return false;
      }
      
      return true
    },
    clearForm(){
      // we done here lets go back
      this.back();
    },
    formatDate(date){
      var year=date.getFullYear();
      var month=(date.getMonth()+101).toString().slice(-2);
      var day=(date.getDate()+100).toString().slice(-2);
      // set date?
      return year+"-"+month+"-"+day;

    },
    convert_date_nl(us_date){
      var date_us=us_date.split("-"); // yyyy-mm-dd;
      var date_nl=date_us[2]+'-'+date_us[1]+'-'+date_us[0]; // dd-mm-yyyy
      return date_nl;
    },
    confirm(){
    
      if(!this.isFormComplete()){
        return;
      }

     this.buttonActive=false;
     setTimeout(()=>{
       this.callApi();
      },500);

    },
    get_absence(){
      var payload={
        id:this.absenceId,
      }

      this.$store.dispatch('get_absence',payload).then(
        result=>{
          this.absence=result.data;

          this.parentName=this.absence.parent_name;
          this.email=this.absence.parent_email;
          this.nameChild=helper.decodeHtml(this.absence.name);
          this.description=this.absence.description;
          this.reason=this.absence.reason;
          this.duration=this.absence.duration;
          this.date=this.absence.date;
        }
      )

    },
    callApi(){

       var payload={
        id:this.absenceId,
        reason_text:this.reason,
        description:this.description,
        exp_duration:this.duration,
        date:this.convert_date_nl(this.date),
      }
      
      //get_absence.php
      // gets dummy promise that always resolves
      this.$store.dispatch('update_absence',payload).then(
        ()=>{
          this.buttonActive=true;
          this.clearForm();
        }
      )
      


    },
    getAbsenceReasons(){
      this.$store.dispatch('get_absence_reasons',{}).then(
        result=>{
         this.absence_reasons=result.data; // converts the observable array to normal array
        }
      )
    },
    
  },
  mounted(){
    this.getAbsenceReasons();
    this.initForm();
    this.get_absence();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.center-text{
  text-align: center;
  margin-bottom:10px;
}
.extra{
  margin-top:10px;
}
img{
  max-width: 60%;
}
.footer{
  margin-top:15px;
  display:flex;
  justify-content: center;
}
.footer .f-img{
  width:80%;
   max-width:250px;
   height:auto;
}
.icon{
  margin-right:5px;
}
</style>
